﻿export const $CURRENCY = $('[data-identity="currency"]');
